<template>
  <div class="caka-tab">
    <div class="caka-tab__scroll" id="topNav">
      <ul class="caka-tab__list" id="topNavUl">
        <li
          v-for="(i, index) in title"
          :key="index"
          :ref="'card-' + index"
          class="caka-tab__item"
          :class="{ 'caka-tab__item--active': selectindex === index }"
          @click="goCenter(i.id, index, $event)"
        >
          <span class="caka-tab__title">{{ i.name }}</span>
          <span
            v-if="i.description"
            class="caka-tab__desc"
            :class="{ 'caka-tab__desc--active': selectindex === index }"
          >{{ i.description }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CakaTab',
  props: {
    title: {
      type: Array
    },
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      selectindex: this.index,
      currentTopNav: '',
      show: false,
      getDate: true
    }
  },
  methods: {
    clossPop() {
      this.show = false
    },
    goCenter(id, index, e) {
      if (this.show) {
        this.show = false
      }
      this.selectindex = index
      let destination = index - 2;
      destination = destination < 0 ? 1 : destination;
      this.currentTopNav = id;
      if (this.navScroll) {
        this.navScroll.scrollToElement(
          document.querySelector('#topNav li:nth-child(' + destination + ')')
        );
      }
      this.getdata(index);
      let ul = document.querySelector('#topNavUl');
      let nav = document.getElementById("topNav");
      let window_offsetWidth = window.innerWidth;
      let dom = e.currentTarget;
      if (dom && ul) {
        let domoffsetWidth = dom.offsetLeft,
          diffWidth = (window_offsetWidth - dom.offsetWidth) / 2,
          targetOffset = -(domoffsetWidth - diffWidth);
        let ul_width = ul.getBoundingClientRect().width;

        if (-targetOffset < 0) {
          nav.scrollLeft = 0;
          return;
        }
        if (targetOffset < window_offsetWidth - ul_width) {
          nav.scrollLeft = -(window_offsetWidth - ul_width);
          return;
        }
        nav.scrollLeft = -targetOffset
      }
    },
    getdata(index) {
      if (this.getDate) {
        this.$emit('scrollToAll', index)
      } else
        this.getDate = true
    }
  },
}
</script>

<style lang="scss" scoped>
.caka-tab {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.caka-tab__scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.caka-tab__list {
  display: inline-flex;
  align-items: flex-end;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem 0;
  margin: 0;
  list-style: none;
  white-space: nowrap;
}

.caka-tab__item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0.75rem 0.5rem;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &--active::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 1.25rem;
    height: 0.125rem;
    background: linear-gradient(90deg, #ff6034, #ee0a24);
    border-radius: 0.125rem;
  }
}

.caka-tab__title {
  font-size: 0.875rem;
  color: #666;
  font-weight: 400;
  line-height: 1.3;
  transition: color 0.2s;

  .caka-tab__item--active & {
    color: #1a1a1a;
    font-weight: 600;
  }
}

.caka-tab__desc {
  margin-top: 0.2rem;
  font-size: 0.625rem;
  color: #999;
  padding: 0.1rem 0.4rem;
  border-radius: 0.625rem;
  max-width: 6.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;

  &--active {
    color: #ee0a24;
    background: #fff1f0;
  }
}
</style>
